import { queryClient } from '@/queryclient';

export const DEFAULT_GOAL = `Hunt for undiscovered 0-day vulnerabilities not yet assigned a CVE. Target CVSS 10.0 severity: network-exploitable, requires no authentication, no user interaction, and achieves remote code execution or complete system compromise. Prioritize weaponizable flaws with high EPSS potential—memory corruption, command injection, deserialization, and authentication bypasses that grant immediate attacker control. Ignore low-impact findings. Focus exclusively on critical, exploit-ready vulnerabilities.`;

// Pipeline options are sourced from the backend capability manifest at runtime
// (see PipelineSelect), so the type is an open string rather than a fixed union.
export type Pipeline = string;

// Friendly labels for known pipeline tiers. Used with a raw fallback
// (PIPELINE_LABELS[opt] ?? opt) so unknown/new tiers still render.
export const PIPELINE_LABELS: Record<string, string> = {
  'premium-bug-rush': 'Premium (Bug Rush)',
  'premium-surgical': 'Premium (Surgical)',
  'premium-legacy': 'Premium',
  'deltascan-repo-full': 'Delta Scan (Full)',
  'deltascan-repo-validate': 'Delta Scan (Validate)',
  medium: 'Medium',
  basic: 'Basic',
};

export function invalidateOsintQueries() {
  queryClient.invalidateQueries({
    predicate: query => {
      const queryKey = query.queryKey as string[];
      return (
        (queryKey[0] === 'MY' && queryKey.includes('osint')) ||
        queryKey[0] === 'OSINT'
      );
    },
    refetchType: 'active',
  });
}
